import cn from 'classnames';
import styles from './Tooltip.module.scss';
import {useState} from "react";
import {useMediaQuery} from 'react-responsive';
import Modal from 'react-modal';

Modal.setAppElement('#root');


export const Tooltip = ({text, video}) => {
    const [open, toggleOpen] = useState(false);

    const [modalIsOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const tooltipClick = () => toggleOpen(!open);

    const isMobile = useMediaQuery({ query: `(max-width: 1024px)` });
    const currentHandler = isMobile ? openModal : tooltipClick;

    return (
        <div className={styles.tooltip}>
            <div className={styles.button} onClick={currentHandler}>
                <div className={cn('h3', styles.quest)}>?</div>
            </div>
            <div className={cn(styles.block, open ? styles.show : '')}>
                <div className={styles.close} onClick={currentHandler} />
                <span>{text}</span>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                overlayClassName={styles.overlay}
                className={cn(styles.modal, video ? styles.history : '')}>
                <div className={styles.closer} onClick={closeModal}/>
                {video}
                <div className={styles.text}>{text}</div>
            </Modal>
        </div>
    )
}